export default __webpack_public_path__ + "static/wedding-af9449c21ac734d0de0a541881d3e0a8.jpg";